import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil } from "@awesome.me/kit-70c1f0055f/icons/classic/light";

interface EditableJobTitleProps {
  value: string;
  onChange: (value: string) => void;
  className?: string;
  placeholder?: string;
  autoFocus?: boolean;
  onBlur?: () => void;
  onKeyDown?: (e: React.KeyboardEvent) => void;
  onStartEdit?: () => void;
}

export default function EditableJobTitle({
  value,
  onChange,
  className = "",
  placeholder = "Enter job title",
  autoFocus = false,
  onBlur,
  onKeyDown,
  onStartEdit,
}: EditableJobTitleProps) {
  const [isEditing, setIsEditing] = useState(false);

  const handleStartEdit = () => {
    setIsEditing(true);
    onStartEdit?.();
  };

  const handleEndEdit = () => {
    setIsEditing(false);
    onBlur?.();
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") {
      setIsEditing(false);
      onBlur?.();
    } else if (e.key === "Escape") {
      setIsEditing(false);
      onBlur?.();
    }
    onKeyDown?.(e);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };

  if (isEditing) {
    return (
      <input
        type="text"
        value={value}
        onChange={handleChange}
        onBlur={handleEndEdit}
        onKeyDown={handleKeyDown}
        autoFocus={true}
        placeholder={placeholder}
        className={`font-mono text-slate-600 dark:text-slate-400 bg-transparent border-b border-slate-300 dark:border-slate-600 focus:outline-none focus:border-indigo-500 dark:focus:border-indigo-400 ${className}`}
      />
    );
  }

  return (
    <span
      className={`font-mono text-slate-600 dark:text-slate-400 cursor-pointer hover:text-indigo-500 dark:hover:text-indigo-400 flex items-center gap-2 ${className}`}
      onClick={handleStartEdit}
    >
      {value}
      <FontAwesomeIcon icon={faPencil} className="text-xs" />
    </span>
  );
}
